module.exports = __webpack_public_path__ + "static/media/udaipur.cb42b6fe.jpg";